export default __webpack_public_path__ + "static/media/meiteli-wenn-due-witt-go-tanzae.99be9ab3.png";